import { Assessment as BookkeepingAssessmentProto } from '@taxfyle/api-internal/internal/bookkeeping_pb'
import { Model } from 'infra/model'
import once from 'lodash/once'
import { computed, makeObservable, observable } from 'mobx'
import { Id, Nullable } from 'types/definitions'
import { DateZero, maybeParseDate } from 'utils/date-util'
import { decimalToNumber, timestampToISO } from 'utils/grpc-util'
import { formatMoney } from 'utils/money-util'

class BookkeepingAssessmentCleanup extends Model<
  BookkeepingAssessmentProto.Cleanup.AsObject,
  BookkeepingAssessmentCleanup
> {
  @observable
  reason = ''

  constructor() {
    super()
    makeObservable(this)
  }

  parse(attrs: Partial<BookkeepingAssessmentProto.Cleanup.AsObject>) {
    return {
      reason: attrs.reason,
    }
  }
}

export default class BookkeepingAssessment extends Model<
  BookkeepingAssessmentProto.AsObject,
  BookkeepingAssessment
> {
  @observable
  id = Id.none

  @observable
  numberOfBankAccounts = 0

  @observable
  avgMonthlyExpenses = 0

  @observable
  comment? = ''

  @observable
  dateAssessed = DateZero()

  @observable
  cleanup: Nullable<BookkeepingAssessmentCleanup> = null

  static get none() {
    return lazyNoneAssessment()
  }

  constructor() {
    super()
    makeObservable(this)
  }

  @computed
  get avgMonthlyExpensesDisplay() {
    return formatMoney(this.avgMonthlyExpenses)
  }

  parse(
    attrs: Partial<BookkeepingAssessmentProto.AsObject>,
  ): Partial<BookkeepingAssessment> {
    return {
      id: attrs.jobId,
      numberOfBankAccounts: attrs.numberOfBankAccounts,
      avgMonthlyExpenses: attrs.avgMonthlyExpenses
        ? decimalToNumber(attrs.avgMonthlyExpenses)
        : undefined,
      comment: attrs.comment?.value,
      dateAssessed:
        maybeParseDate(timestampToISO(attrs.dateAssessed)) || DateZero(),
      cleanup: attrs.cleanup
        ? new BookkeepingAssessmentCleanup().set(attrs.cleanup)
        : undefined,
    }
  }
}

const lazyNoneAssessment = once(() => new BookkeepingAssessment())
